import { render, staticRenderFns } from "./planInfo.vue?vue&type=template&id=4e39cab8&scoped=true&"
import script from "./planInfo.vue?vue&type=script&lang=js&"
export * from "./planInfo.vue?vue&type=script&lang=js&"
import style0 from "./planInfo.vue?vue&type=style&index=0&id=4e39cab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39cab8",
  null
  
)

export default component.exports